export default __webpack_public_path__ + "static/media/full-vampire.4045b0c0.jpg";